if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        this.onThumbnailClick = this.onThumbnailClick.bind(this);
        this.onSlideChanged = debounce(this.onSlideChanged.bind(this), 500);
        this.addEventListener('click', this.onThumbnailClick);

        this.refreshElements();
        this.elements.viewer?.addEventListener('slideChanged', this.onSlideChanged);

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      refreshElements() {
        this.elements.viewer = this.querySelector('[id^="GalleryViewer"]');
        this.elements.thumbnails = this.querySelector('[id^="GalleryThumbnails"]');
      }

      onThumbnailClick(event) {
        const thumbnails = this.querySelector('[id^="GalleryThumbnails"]');
        if (!thumbnails?.contains(event.target)) return;

        const button = event.target.closest('button');
        const mediaToSwitch = event.target.closest('[data-target]');
        if (!button || !mediaToSwitch) return;

        event.preventDefault();
        this.setActiveMedia(mediaToSwitch.dataset.target, false);
      }

      onSlideChanged(event) {
        const thumbnails = this.querySelector('[id^="GalleryThumbnails"]');
        if (!thumbnails) return;

        const thumbnail = thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        this.refreshElements();

        const viewer = this.elements.viewer;
        const thumbnails = this.elements.thumbnails;
        const activeMedia =
          viewer?.querySelector(`[data-media-id="${mediaId}"]`) || viewer?.querySelector('[data-media-id]');
        if (!viewer || !activeMedia) {
          return;
        }

        viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (thumbnails) {
            const activeThumbnail = thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail && activeThumbnail.parentElement.firstChild !== activeThumbnail) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (viewer.slider) viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!thumbnails) return;
        const activeThumbnail = thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail?.dataset?.mediaPosition) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        const thumbnails = this.querySelector('[id^="GalleryThumbnails"]');
        if (!thumbnails || !thumbnail) return;

        thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button')?.setAttribute('aria-current', true);
        if (thumbnails.isSlideVisible?.(thumbnail, 10)) return;

        thumbnails.slider?.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        const viewer = this.querySelector('[id^="GalleryViewer"]');
        if (!viewer?.slider) return;
        viewer.slider.setAttribute('role', 'presentation');
        viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
